import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { CheckCircle } from '@phosphor-icons/react'

export function EmailVerifiedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-muted/50 to-background px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-green-500/10 flex items-center justify-center">
            <CheckCircle size={48} weight="fill" className="text-green-500" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-3">Email Verified!</h1>
        <p className="text-muted-foreground mb-8">
          Your email has been successfully verified. You can now log in to your account.
        </p>
        
        <Link to="/login">
          <Button size="lg" className="w-full">
            Go to Login
          </Button>
        </Link>
      </div>
    </div>
  )
}
